import { useState } from 'react';
import CloseIcon from '../../../assets/icons/close.svg?react';
import { useAddContact } from '../../../hooks/queries/smsQueries';

const SmsContactAppendSideModal = ({ onClose, onSuccess }) => {
  const { mutate: addContact, isPending } = useAddContact();
  const [contactObject, setContactObject] = useState({
    name: null,
    phoneNumber: null,
    organization: null,
  });
  const [phoneError, setPhoneError] = useState('');

  const phoneRegex = /^0\d{1,2}-\d{3,4}-\d{4}$/;

  const handleContactObject = (e) => {
    const { id, value } = e.target;
    setContactObject({ ...contactObject, [id]: value });
    
    // 연락처 입력 시 실시간 검증
    if (id === 'phoneNumber') {
      if (value && !phoneRegex.test(value)) {
        setPhoneError('올바른 연락처 형식이 아닙니다. (예: 010-1234-5678)');
      } else {
        setPhoneError('');
      }
    }
  };

  // 버튼 활성화 조건: 모든 필수 필드 입력 + 연락처 형식 검증
  const isFormValid = 
    contactObject.name && 
    contactObject.phoneNumber && 
    contactObject.organization &&
    phoneRegex.test(contactObject.phoneNumber);

  const handleContactAppend = () => {
    if (!isFormValid) {
      return;
    }

    addContact(contactObject, {
      onSuccess: () => {
        onSuccess();
        onClose();
      },
      onError: (error) => {
        console.error('연락처 추가 실패:', error);
        alert('연락처 추가에 실패했습니다.');
      }
    });
  };

  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>연락처 추가</h3>
          <div className="side-modal-close" onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
        <div className="side-modal-content">
          <table className='transparent-table w-full'>
            <tr>  
              <td>
                <label htmlFor="name" className='w-20 mr-10 text-b2-700 required'>이름</label>
              </td>
              <td>
                <input 
                  value={contactObject.name || ''} 
                  type="text" 
                  id="name" 
                  className='w-full input-primary' 
                  placeholder='이름을 입력해주세요.' 
                  onChange={handleContactObject} 
                  autoComplete='off'
                />
              </td>
            </tr> 
            <tr>
              <td>
                <label htmlFor="phoneNumber" className='w-20 mr-10 text-b2-700 required'>연락처</label>
              </td>
              <td>
                <input 
                  value={contactObject.phoneNumber || ''} 
                  type="text" 
                  id="phoneNumber" 
                  className={`w-full input-primary ${phoneError ? 'error' : ''}`}
                  placeholder='연락처를 입력해주세요. 대시(-) 포함' 
                  onChange={handleContactObject} 
                  autoComplete='off'
                />
              </td>
            </tr>
            {phoneError && (
              <tr>
                <td colSpan="2">
                  <p className='text-b3-400 text-red-500 mt-5'>{phoneError}</p>
                </td>
              </tr>
            )}
            <tr>
              <td>
                <label htmlFor="organization" className='w-20 mr-10 text-b2-700 required'>조직</label>
              </td>
              <td>
                <input 
                  value={contactObject.organization || ''} 
                  type="text" 
                  id="organization" 
                  className='w-full input-primary' 
                  placeholder='조직을 입력해주세요.' 
                  onChange={handleContactObject} 
                  autoComplete='off'
                />
              </td>
            </tr>
          </table>
          <div className='flex justify-end w-full'>
            <button 
              className='btn big-btn btn-primary flex-1' 
              onClick={handleContactAppend} 
              disabled={isPending || !isFormValid}
            >
              {isPending ? '등록 중...' : '등록하기'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmsContactAppendSideModal;
